import React from 'react';
import { Provider } from 'react-redux'
import store from '../store';
import { BrowserRouter, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
// import Preloader from './Preloader';

// import Header from './Header';
import PreloadScreen from './PreloadScreen';
import ScrollToTop from './ScrollToTop';

import "../assets/css/normalize.css";
import "../assets/css/common.css";
import "../assets/css/fonts.css";
import "../assets/css/header.css";
import "../assets/css/preloader.css";
import "../assets/css/footer.css";
import "../assets/css/homepage.css";
import "../assets/css/homepage-wet.css";
import "../assets/css/homepage-mort-ou-vif.css";
import "../assets/css/homepage-valsalva.css";
import "../assets/css/homepage-ratp.css";
import "../assets/css/homepage-renault.css";
import "../assets/css/homepage-doolittle.css";
import "../assets/css/homepage-telegraph.css";
import "../assets/css/homepage-au-tate.css";
import "../assets/css/about.css";
import "../assets/css/all-works.css";
import "../assets/css/svg-patterns.css";
import "../assets/css/responsive-screen.css";

class App extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<Provider store={store}>
				<BrowserRouter>
                    <ScrollToTop>
                        <Helmet>
                            <title>La Roulotte Retouche</title>
                            <meta name="description" content="Global description" />
                        </Helmet>
						{/*<LangMenu/>*/}
						{/*<LangSelector>*/}
							{/*<Preloader>*/}
								{/*<div>
							    </div>*/}
							{/*</Preloader>*/}
						{/*</LangSelector>*/}
						{/*<Switch>*/}
						<Route path="/:url?" component={PreloadScreen}/>
				    	{/*</Switch>*/}
				    </ScrollToTop>
				</BrowserRouter>
			</Provider>
		)
	}
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js